import React, { Suspense } from 'react' 
import GallerySlider from '../GallerySlider'
import { get_portfolio_categories, get_portfolio_category_items } from '../../services/facade/portfolio_service'
import './portfolio.css'
import { LoadingViewPlacholder } from '../Template'
import optimized_data from '../../data/optimized_portfolio_previews.json'


const PortfolioCategoryPreview = ({ photos, title }) => {
    return (
        <section className='portfolio-category'>
            <h2>{title.toUpperCase()}</h2>
            <Suspense fallback={<LoadingViewPlacholder />}>
                <GallerySlider photos={photos} />
            </Suspense>
        </section>
    )
}

// TODO: improve/simplify the data loading, or just hard code it.  It takes forever to render.
export default function Portfolio() {

    /**
     * TODO: find a way to optimize the data mapping done here, as it takes a long time to load. 
     * Maybe fetch and display the data for each category one at a time (inside the PortfolioCategoryPreview components?) instead of waiting for it to all load at once.
     */
    // const [categories, setCategories] = useState([])
    // const [categoryPreviews, setCategoryPreviews] = useState([])

    // async function fetchCategoryPreviews() {
    //     // console.log('called getCategoryPreviews')
    //     // console.log('categories: ', categories) 
    //     const previews_data = []
    //     categories.forEach(async (category) => {
    //         const category_items = await get_portfolio_category_items(category.items)
    //         // console.log('category_items: ', category_items)
    //         const category_item_previews = category_items.data.map((item, i) => ({ url: item.photos[0], description: item.title }))
    //         // console.log('category_item_previews: ', category_item_previews)
    //         const mapped_category = { ...category, items: [...category_item_previews] }
    //         // console.log('mapped_category: ' , mapped_category) 
    //         // console.log('previews_data : ', JSON.stringify(previews_data))
    //         previews_data.push(mapped_category)
    //     })
    //     setCategoryPreviews(previews_data)
    //     console.log('previews_data', previews_data)
    // }

    // async function fetchData() {
    //     const fetched_categories = get_portfolio_categories()
    //     setCategories(fetched_categories.data)
    // }

    // useEffect(() => {
    //     fetchData()
    // }, [])

    // useEffect(() => {
    //     fetchCategoryPreviews()
    // }, [categories])


    const categoryPreviews = optimized_data.categories
    return (
        <React.Fragment>
            <br /><br />
            <div className="main-content">
                {categoryPreviews.map((cp, i) => <PortfolioCategoryPreview
                    key={i}
                    photos={cp.items}
                    title={cp.title} />
                )}
            </div>
             <br /><br />
        </React.Fragment>

    )
}

